import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Divider } from 'antd';
import styled from 'styled-components';
import classNames from 'classnames';
import CloseAlerts from 'Components/alerts/assets/svg/CloseAlerts';
import {
  maxTablet,
  maxWidth,
  midWidthApp,
  primaryFont,
  retina,
  SecondaryColor,
  secondaryFont,
  wLight,
  wMBold,
  wMedium,
  loadingGifV6,
  maxMobile,
} from '../../../Utils/utilsStyle';
import PeopleWidgetWithOutHolo from './PeopleWidgetWithOutHolo';
import { Executive } from '../../../Types/PersonTypes';
import { convertDateFormat, getLocalStorageValue } from '../../../Utils/UtilityFunctions';
import PeopleMoveReasonCard from '../../people/components/PeopleMoveReasonCard';
import ArticleInsightSearchIcon from '../assets/svgIcons/ArticleInsightSearchIcon';
import StopIcon from '../assets/svgIcons/StopIcon';
import { selectArticle, selectArticleInsight, selectArticleInsightsLoaded, selectArticleInsightsHistory, selectArticleInsightsHistoryLoaded, selectArticleInsightsLoading } from '../../../Selector/ArticleSector';
import { actions } from '../../../Slice/ArticlesSlice';
import { actions as helperActions } from '../../../Slice/HelperSlice';
import { usePrevious } from '../../../Utils/hooks/usePrevious';

interface PromptInputProps {
  additionalClassName?: string;
  showSearchContainer?: boolean;
  personYou: Executive;
  handleNewPrompt: () => void;
  disabled?: boolean;
}

const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 80vh;
    .insights-header {
      margin: 0 30px;
    }

    .close-insights {
      position: fixed;
      right: 10px;
      top: 15px;
      z-index: 1000;
      @media all and (max-width: ${maxMobile}) {
        right: 35px;
      }
    }

    .insight-heading {
      margin-top: 12px;
      font-family: ${secondaryFont};
      font-size: 46px;
      line-height: 44px;
      color: #424B50;
      font-weight: ${wMBold};
      letter-spacing: -0.958px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 32px;
        line-height: 28px;
      }
    }
    .insights-sub-header {
      display: flex;
      flex-direction: row;
      gap: 12px;
      border-radius: 8px;
      border: 1.149px solid #D8D8D8;
      background: #FFF;
      padding: 8px;
    }
    .insight-header-content {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      min-width: 0;
    }
    .insight-header-text {
      font-family: ${secondaryFont};
      font-size: 16px;
      line-height: 18px;
      color: #0D0D0D;
      letter-spacing: -0.299px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }
    .insight-header-sub-text {
      font-family: ${primaryFont};
      font-weight: ${wLight};
      line-height: 14px;
      font-size: 14px;
      letter-spacing: -0.42px;
      color: #424B50;
      .date::before {
        content: " | ";
        color: #CFCFCF;
      }
    }
    .add-prompt{
      display: flex;
      align-items: center;
      cursor: pointer;
      height: 50px;
      .add-prompt-input {
        width: 100%;
        margin-left: 12px;
        font-style: italic;
        padding: 5px 10px 5px 20px;
        border-radius: 5px;
        border: 1px solid #E4E4E4;
        font-family: ${primaryFont};
        font-size: 14px;
        line-height: 18px;
        font-weight: ${wLight};
        color: #E4E4E4;
      }
      &.disabled {
        cursor: not-allowed;
        opacity: 0.5;
        pointer-events: none;
      }
      
      &.prompt-container {
        background: #fff;
        padding-top: 12px;
        margin-top: auto;
        position: sticky;
        bottom: 0;
        z-index: 2;
      }
    }

    .add-prompt-container {
      width: 100%;
      margin-top: auto;
      background: #fff;

      &.expanded-prompt {
        position: sticky;
        bottom: 0;
        z-index: 2;
      }

      &.top-expanded {
        position: relative;
        bottom: auto;
        margin-top: 0px;
      }

      &.generating {
        position: relative;
        margin-top: 12px;
        z-index: 1;
        background: #fff;
      }
    }
    .loader-div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      width: 100%;
      min-height: 500px;
      margin-top: 0;
      padding: 16px;
      .img-loader-popup {
        height: 140px;
        width: 140px;
      }
    }
    .agent-builder-btn {
      cursor: pointer;
      border-radius: 6px;
      background: ${SecondaryColor};
      padding: 8px 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFF;
      font-family: ${primaryFont};
      font-size: 14px;
      font-weight: ${wMedium};
      line-height: normal;
      max-height: 30px;
      border: 1px solid ${SecondaryColor};
      @media all and (max-width: ${midWidthApp}) {
        padding: 2px 8px;
      }
      @media all and (max-width: ${maxTablet}) {
        font-size: 12px;
        padding: 6px 8px;
      }
      &.cancel-btn {
        background: #fff;
        color: #667982;
        font-size: 14px;
        margin-right: 8px;
        border-radius: 6px;
        border: 1px solid #667982;
        @media all and (max-width: ${maxTablet}) {
          font-size: 12px;
          padding: 6px 8px;
        }
        &.stopGenBtn {
          color: #CB2B1D;
          border: 1px solid #CB2B1D;
          svg {
            margin-left: 4px;
          }
        }
      }

`;

const Image = styled.img`
  height: 42px;
  width: 47px;
  min-width: 47px;
  border-radius: 8px;
  background-position: center;
  background-size: cover;
  flex-shrink: 0;
`;

const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  flex: 1;
  height: 100%;
  .search-icon {
    margin-bottom: 16px;
  }
  .search-text {
    font-size: 14px;
    line-height: 18px;
    color: #424B50;
    font-weight: ${wMedium};
    max-width: 300px;
  }
`;

const PromptInput: React.FC<PromptInputProps> = ({
  additionalClassName = '',
  showSearchContainer = false,
  personYou,
  handleNewPrompt,
  disabled = false,
}) => (
  <>
    <div
      className={`add-prompt ${additionalClassName} insights-header ${disabled ? 'disabled' : ''}`}
      onClick={!disabled ? handleNewPrompt : undefined}
      onKeyPress={!disabled ? handleNewPrompt : undefined}
      role="button"
      tabIndex={disabled ? -1 : 0}
    >
      <PeopleWidgetWithOutHolo
        diameter="31px"
        diameterSm="31px"
        diameterXsm="31px"
        logo={personYou?.personImage || ''}
        wrapperColor={getLocalStorageValue('personalitycolors') || ''}
        margin="0"
        ringPadding="2px"
        ringPaddingSm="2px"
      />
      <span
        className="add-prompt-input"
      >
        Write your Prompt...
      </span>
    </div>
    {showSearchContainer && (
      <SearchContainer>
        <div className="search-icon">
          <ArticleInsightSearchIcon />
        </div>
        <p className="search-text">
          Have questions? Let Gilroy break down the details for you.
        </p>
      </SearchContainer>
    )}
  </>
);

PromptInput.defaultProps = {
  additionalClassName: '',
  showSearchContainer: false,
};

type Props = {
  onClose: () => void;
};

const defaultProps = {};

export interface ArticleInsight {
  insightId: number;
  question: string;
  answer: string | null;
  isLoading: boolean;
  insightResponseId: number;
}

const ArticleInsightPanel = function ArticleInsightPanel(props: Props) {
  const { onClose } = props;
  const dispatch = useDispatch();
  const article = useSelector(selectArticle);
  const previousArticle = usePrevious(article);
  const articleInsight: ArticleInsight = useSelector(selectArticleInsight);
  const articleInsightsLoading = useSelector(selectArticleInsightsLoading);
  const articleInsightsLoaded = useSelector(selectArticleInsightsLoaded);
  const articleInsightsHistory: ArticleInsight[] = useSelector(selectArticleInsightsHistory);
  const articleInsightsHistoryLoaded = useSelector(selectArticleInsightsHistoryLoaded);
  const [personYou, setPersonYou] = useState<Executive>();
  const [addPrompt, setAddPrompt] = useState<boolean>(false);
  const [newNote, setNewNote] = useState<{
    comment: {
      person: Executive;
      text: string;
      type: string;
      dateTimeStamp: string;
      editable: boolean;
      noteId: number;
      changed: boolean;
      entities: Record<string, unknown>;
    };
  }>();
  const [stopGenerating, setStopGenerating] = useState<boolean>(false);
  const [isNewRequest, setIsNewRequest] = useState<boolean>(false);
  const generatingRef = useRef<HTMLDivElement | null>(null);
  const expanderContainerRef = useRef<HTMLDivElement | null>(null);
  const [localInsights, setLocalInsights] = useState<Array<ArticleInsight>>([]);
  const hasHistory = Boolean(localInsights?.length);

  const handleStopGenerating = () => {
    setStopGenerating(true);
    setAddPrompt(false);
  };

  const handleNewPrompt = () => {
    if (!addPrompt) {
      setAddPrompt(true);
      setNewNote({
        comment: {
          person: personYou!,
          text: '',
          type: '',
          dateTimeStamp: '',
          editable: false,
          noteId: 0,
          changed: false,
          entities: {},
        },
      });

      // Auto-focus the input field after state updates
      setTimeout(() => {
        const contentEditable = document.getElementById('contenteditablediv') as HTMLElement;
        if (contentEditable) {
          contentEditable.focus();
        }
      }, 100);
    }
  };

  const handleNewNote = () => {
    setAddPrompt(false);
  };

  const handleGeneratePrompt = (promptText: string) => {
    setIsNewRequest(true);
    const tempId = Date.now();

    setLocalInsights(prev => [
      ...prev,
      {
        insightId: tempId,
        question: promptText,
        answer: null,
        isLoading: true,
        insightResponseId: tempId,
      },
    ]);

    if (article && personYou) {
      dispatch(actions.getArticleInsight({
        articleId: article.articleId,
        companyId: article.companyId,
        prompt: promptText,
      }));
      dispatch(actions.setArticleInsightsExplored(0));
    }
  };

  useEffect(() => {
    setPersonYou({
      personName: getLocalStorageValue('fullname') || '',
      personImage: getLocalStorageValue('profilePic') || '',
      companyName: getLocalStorageValue('personCompany') || '',
      personDesignation: getLocalStorageValue('personDesignation') || '',
      location: '',
      companyId: 0,
      companyLogo: '',
      executiveType: '',
      headline: '',
      personId: 0,
      archeType: {
        personality: '',
        color: '',
        name: '',
        image: '',
      },
      personAdded: false,
      personalityTypes: [],
      feedid: 0,
    });
  }, []);

  useEffect(() => {
    if (article && article.articleId !== previousArticle?.articleId) {
      dispatch(actions.getArticleInsightHistory({
        articleId: article.articleId,
        companyId: article.companyId,
      }));
    }
  }, [article, previousArticle, dispatch]);

  useEffect(() => {
    if (articleInsightsHistoryLoaded) {
      setLocalInsights(articleInsightsHistory || []);
    }
  }, [articleInsightsHistoryLoaded]);

  useEffect(() => {
    setLocalInsights([]);
    setAddPrompt(false);
  }, [article?.articleId]);

  useEffect(() => {
    if (articleInsightsLoading && stopGenerating) {
      setLocalInsights(prev => prev.filter((item) => !item.isLoading));
      setAddPrompt(false);
    }
    if (articleInsightsLoading) {
      generatingRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }

  }, [articleInsightsLoading, articleInsightsLoaded, stopGenerating]);

  useEffect(() => {
    if (articleInsightsLoaded && articleInsight && !stopGenerating && isNewRequest) {
      dispatch(helperActions.setNotification({
        message: 'Article insights generated successfully',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
      }));
      setLocalInsights((prev) => prev.map((item) => item.isLoading ? {
        ...item,
        answer: articleInsight.answer,
        insightResponseId: articleInsight.insightResponseId,
        insightId: articleInsight.insightId,
        isLoading: false,
      } : item));
      setAddPrompt(false);
      setIsNewRequest(false);
    }
    if (articleInsightsLoaded && articleInsight && stopGenerating) {
      dispatch(actions.getArticleInsight({
        stopGeneration: true,
        insightResponseId: articleInsight?.insightResponseId,
        insightId: articleInsight?.insightId,
      }));
      setLocalInsights((prev) => prev.filter((item) => !item.isLoading));
      setStopGenerating(false);
    }
  }, [articleInsightsLoaded, articleInsight, stopGenerating]);

  // Scroll to bottom when there's message history
  useEffect(() => {
    if (addPrompt) {
      setTimeout(() => {
        const scrollContainer = document.querySelector('.article-insight');
        if (scrollContainer) {
          scrollContainer.scrollTo({
            top: scrollContainer.scrollHeight,
            behavior: 'smooth',
          });
        }
      }, 300);
    }
  }, [articleInsightsHistoryLoaded, localInsights, addPrompt]);

  // Handle click outside to close expander container
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (expanderContainerRef.current
        && !expanderContainerRef.current.contains(event.target as Node)
        && !articleInsightsLoading) {
        setAddPrompt(false);
      }
    };

    if (addPrompt) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [addPrompt, articleInsightsLoading]);

  return (
    <StyledWrapper>
      <div className="insights-header">
        <span onClick={onClose} onKeyPress={onClose} tabIndex={0} role="button" aria-label="close" className="close-alerts close-insights"><CloseAlerts /></span>
        <h1 className="insight-heading">Article Insights</h1>
        <div className="insights-sub-header">
          {article?.image &&
            <Image className="article-image" src={article?.image} alt="article-insight-image" />
          }
          <div className="insight-header-content">
            <h4 className="insight-header-text">{article?.title}</h4>
            <span className="insight-header-sub-text">
              <span className="domain">{article?.domain}</span>
              <span className="date">{article?.date ? convertDateFormat(article.date) : ''}</span>
            </span>
          </div>
        </div>
      </div>
      <Divider style={{ marginTop: '16px', marginLeft: 0, marginRight: 0, marginBottom: 0 }} />
      {personYou && !addPrompt && localInsights?.length === 0
        ? (
          <PromptInput
            showSearchContainer
            personYou={personYou}
            handleNewPrompt={handleNewPrompt}
            disabled={articleInsightsLoading}
          />
        ) : ''}
      {articleInsightsHistoryLoaded && localInsights?.length > 0 ? (
        <>
          {localInsights.map((item: ArticleInsight) => (
            <div key={item.insightId}>
              {/* USER QUESTION */}
              <PeopleMoveReasonCard
                notes={{
                  comment: {
                    person: personYou!,
                    text: item.question,
                    type: '',
                    dateTimeStamp: '',
                    editable: false,
                    noteId: item.insightId,
                    changed: false,
                    entities: {},
                  },
                }}
                isPeopleNotes={false}
                isCompanyNotes={false}
                showReminderButton={false}
                isPrompt
              />

              {/* GILROY ANSWER */}
              {item.answer && (
                <PeopleMoveReasonCard
                  notes={{
                    comment: {
                      person: personYou!,
                      text: item.answer,
                      type: '',
                      dateTimeStamp: '',
                      editable: false,
                      noteId: item.insightResponseId,
                      changed: false,
                      entities: {},
                    },
                  }}
                  isPeopleNotes={false}
                  isCompanyNotes={false}
                  showReminderButton={false}
                  isPromptResponse
                />
              )}
            </div>
          ))}
        </>
      ) : null}

      {/* Add prompt input container at bottom when adding new prompt */}
      {addPrompt && newNote && (
        <div
          ref={expanderContainerRef}
          className={classNames(
            'add-prompt-container expanded-prompt',
            {
              generating: articleInsightsLoading,
              'top-expanded': !hasHistory,
            },
          )}
        >
          {!articleInsightsLoading ? (
            <PeopleMoveReasonCard
              key="article-insight-prompt-input"
              notes={newNote}
              isNewNoteOpen={addPrompt}
              newNote
              isPrompt
              noEdit
              enableTagging={false}
              isPeopleNotes={false}
              isCompanyNotes={false}
              handleNewNoteCancel={handleNewNote}
              showReminderButton={false}
              onGeneratePrompt={handleGeneratePrompt}
            />
          ) : null}
          {articleInsightsLoading && (
            <div className="loader-div" ref={generatingRef}>
              <img className="img-loader-popup" src={loadingGifV6} alt="Generating insights..." />
              <span
                role="button"
                tabIndex={0}
                onClick={handleStopGenerating}
                onKeyPress={handleStopGenerating}
                className={classNames('agent-builder-btn cancel-btn stopGenBtn')}
              >
                Stop Generating
                <StopIcon />
              </span>
            </div>
          )}
        </div>
      )}

      {/* Prompt container at bottom when history exists */}
      {articleInsightsHistoryLoaded && localInsights?.length > 0 && personYou && !addPrompt && (
        <PromptInput
          additionalClassName="prompt-container"
          personYou={personYou}
          handleNewPrompt={handleNewPrompt}
          disabled={articleInsightsLoading}
        />
      )}
    </StyledWrapper>
  );
};

ArticleInsightPanel.defaultProps = defaultProps;
export default ArticleInsightPanel;
